import { cookieStorage } from '@muse-web/storages'

import { USER_COUNTRY_COOKIE_NAME } from '../constants/cookieKeys'
import { DEFAULT_COUNTRY_CODE } from '../constants/defaultCountryCode'

export const getCountryCodeFromCookie = (): string => {
    if (typeof window === 'undefined') {
        return DEFAULT_COUNTRY_CODE
    }

    return cookieStorage.get(USER_COUNTRY_COOKIE_NAME) ?? DEFAULT_COUNTRY_CODE
}
